import MuiAlertTitle, { AlertTitleProps } from '@mui/material/AlertTitle';

export interface IAlertTitleProps extends AlertTitleProps {}

const AlertTitle = (props: IAlertTitleProps): JSX.Element => {
  return <MuiAlertTitle {...props} />;
};

export default AlertTitle;
